import React, { useState,useEffect } from "react";
import { BtnAlmacenar} from "componentes/templates/btn_crud";
import { POST } from 'helpers/request'
import LanguageHelper from 'helpers/language_helper'

export default function FormNotesIndicators({ ind_int_id }) {

  

  /* Arreglo con las variables para colocar los datos en el formulario */
  const variables = [
    "not_txt_name",
    "not_sts_register",
    "ind_int_id"
  
  ];

  const [actualizar] = useState(false);

  
  const gestionarCambio = (event) => {
    if (event.target.type === "radio") {
      localStorage.setItem(event.target.name, event.target.value);
    } else {
      localStorage.setItem(event.target.id, event.target.value);
    }
  };


  const Verificar = (result) => {
    let resultado = result;
    if (resultado.status === 201) {
      alert(resultado.messages);
      // limpiar el storage
      variables.forEach(function (valor) {
        localStorage.removeItem(valor);
      });
      window.location.reload();
    } else {
      // regresó error (normalmente 400), no pasó la validación
      variables.forEach(function (valor) {
        // es el mensaje de error q devuelve la validacion del codeigniter
        if (document.getElementById(valor + "_msj") !== null) {
          let mensaje = resultado[valor];
          document.getElementById(valor + "_msj").classList.remove("is-hidden");
          document.getElementById(valor + "_msj").textContent = mensaje;
        }

      });
    }
  };

  
  const gAlmacenar = async (e) => {
    e.preventDefault();
    localStorage.setItem("ind_int_id", ind_int_id);
    try {
      const data = await POST(variables, "indicators/notes");
      // console.log(res);
      Verificar(data);
      
    } catch (error) {
      console.log("error", error)
    }
    
  };

  
useEffect(() => {
  variables.forEach(function (valor) {
    localStorage.removeItem(valor);
  });

 
  // eslint-disable-next-line
}, [actualizar])


  return (
    <div className="container is-fluid">
      <div className="columns">
        <div className="column is-12 is-offset-0">
          

          <form autoComplete="nope">
          <div className="field">
              <label className="label">{LanguageHelper.getLanguageString('NotesIndicators.name')}</label>
              <div className="control has-icons-left">
                <textarea
                 
                  placeholder={LanguageHelper.getLanguageString('NotesIndicators.name')}
                  className="textarea"
                  id="not_txt_name"
                  required
                  onChange={gestionarCambio}
                  maxLength="512"
                />
                
              </div>
              <p
                className="is-hidden help is-danger"
                id="not_txt_name_msj"
              ></p>
          </div>       
            
           
              <BtnAlmacenar gAlmacenar={gAlmacenar}>{LanguageHelper.getLanguageString('NotesIndicators.save')}</BtnAlmacenar>
            
          </form>
        </div>
        

      </div>
      
    </div>
  );
}
